<section>
  <div class="cg-inner-page-wrapper">
    <!-- Legal Links Row  -->
    <div class="footer-legal-links cg-margin-bottom-lg">
      <button
        *ngIf="hasOneTrustEnabled && !isLoggedIn"
        cignaButton="link"
        data-test-id="cookie-preferences"
        style="padding: 0"
        class="ot-sdk-show-settings"
        [cignaTrackClicks]="[
          'trackEventOther',
          'Cookie Preferences',
          'ac22401',
          {
            eVar120: 'footer-legal-links',
            eVar119: 'US1881012'
          }
        ]"
      >
        Cookie Preferences
      </button>
      <a
        target="_blank"
        data-test-id="nondiscrimination-notice"
        href="https://www.evernorth.com/nondiscrimination"
        [cignaTrackClicks]="[
          'trackEventOther',
          'Nondiscrimination Notice',
          'ac22401',
          {
            eVar120: 'footer-legal-links',
            eVar119: 'US1881012'
          }
        ]"
        >Nondiscrimination Notice</a
      >
      <a
        target="_blank"
        data-test-id="privacy"
        href="https://www.evernorth.com/privacy-policy"
        [cignaTrackClicks]="[
          'trackEventOther',
          'Privacy',
          'ac22401',
          {
            eVar120: 'footer-legal-links',
            eVar119: 'US1881012'
          }
        ]"
        >Privacy Notice</a
      >
      <button
        cignaButton="link"
        data-test-id="site-help"
        style="padding: 0"
        (click)="openSiteHelpModal()"
      >
        Site Help
      </button>
      <a
        target="_blank"
        data-test-id="site-specific-terms"
        [href]="
          '/resourceLibrary/provider/disclaimers/siteSpecificTerms'
            | resourceLink : { targetApp: 'evernorth', secure: false }
            | async
        "
        [cignaTrackClicks]="[
          'trackEventOther',
          'Site Specific Terms',
          'ac22401',
          {
            eVar120: 'footer-legal-links',
            eVar119: 'US1881012'
          }
        ]"
        >Site Specific Terms</a
      >
      <a
        target="_blank"
        data-test-id="terms-of-use"
        href="https://www.evernorth.com/terms-of-use"
        >Terms of Use</a
      >
    </div>
  </div>

  <div class="footer-line"></div>

  <div class="cg-inner-page-wrapper cg-margin-top-lg disclaimers">
    <div>
      Availability of programs and services may vary by location and is subject
      to change.
    </div>
    <div class="cg-margin-top-lg">
      &copy;{{ currentYear }} Evernorth. All rights reserved. All products and
      services are provided by or through operating subsidiaries or affiliates
      of Evernorth.
    </div>
    <div class="footer-disclaimer cg-margin-top-lg cg-margin-bottom-lg">
      <cigna-icon
        type="external-link"
        class="cg-mat-icon-link-left green-icon"
      ></cigna-icon>
      Selecting these links will take you away from provider.evernorth.com.
      Evernorth does not control the linked sites' content or links.
      <a
        class="lower-footer__link"
        data-test-id="details"
        href="https://www.evernorth.com/terms-of-use"
        target="_blank"
        rel="noopener noreferrer"
        >Details</a
      >
    </div>
  </div>
</section>
